import * as XLSX from "xlsx";

const fmtNum = (n) => Number(n || 0);

const formatPrintedTime = () => {
  const now = new Date();
  const datePart = now.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const timePart = now.toLocaleTimeString("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${datePart}, ${timePart.replace(".", ":")} WIB`;
};

export async function exportInventoryStockToExcel({
  storeInfo = {},
  stockGroups = [],
  rawStocks = [],
  categoryName = "",
  searchTerm = "",
}) {
  const storeName = storeInfo.name || localStorage.getItem("tenantName") || "Toko";
  const storeAddress = storeInfo.address || "";

  // Normalize data list from grouped products or flat list
  let itemsToExport = [];
  if (stockGroups && stockGroups.length > 0) {
    itemsToExport = stockGroups.flatMap((group) => group.variants || [group]);
  } else if (rawStocks && rawStocks.length > 0) {
    itemsToExport = rawStocks;
  }

  const dataRows = [];

  // 1. Header Information
  dataRows.push([storeName.toUpperCase()]);
  if (storeAddress) dataRows.push([storeAddress]);
  dataRows.push(["LAPORAN PERSEDIAAN STOK INVENTORI"]);
  dataRows.push([`Waktu Cetak: ${formatPrintedTime()}`]);
  if (categoryName) {
    dataRows.push([`Filter Kategori: ${categoryName}`]);
  }
  if (searchTerm) {
    dataRows.push([`Kata Kunci Pencarian: "${searchTerm}"`]);
  }
  dataRows.push([]);

  // Calculate totals
  let totalCurrentStock = 0;
  let totalBeginningStock = 0;
  let totalStockIn = 0;
  let totalStockOut = 0;
  let totalValuation = 0;
  let lowStockCount = 0;

  itemsToExport.forEach((item) => {
    const curStock = fmtNum(item.current_stock);
    const minStock = fmtNum(item.minimum_stock);
    const costPrice = fmtNum(item.cost_price || item.purchase_price || item.buying_price);

    totalCurrentStock += curStock;
    totalBeginningStock += fmtNum(item.beginning_stock);
    totalStockIn += fmtNum(item.stock_in);
    totalStockOut += fmtNum(item.stock_out);
    totalValuation += curStock * costPrice;

    if (curStock <= minStock) {
      lowStockCount++;
    }
  });

  // 2. Summary Metrics Row
  dataRows.push([
    "TOTAL ITEM",
    itemsToExport.length,
    "TOTAL STOK SAAT INI",
    totalCurrentStock,
    "ITEM MENIPIS/HABIS",
    lowStockCount,
    "TOTAL ESTIMASI NILAI MODAL",
    totalValuation,
  ]);
  dataRows.push([]);

  // 3. Table Column Headers
  dataRows.push([
    "No",
    "Kode Produk / Barcode",
    "Nama Produk",
    "Varian / Opsi",
    "Kategori",
    "Stok Awal",
    "Stok Masuk",
    "Stok Keluar",
    "Stok Saat Ini",
    "Satuan",
    "Stok Minimum",
    "Status Stok",
    "Harga Modal (Rp)",
    "Harga Jual (Rp)",
    "Total Nilai Modal (Rp)",
  ]);

  // 4. Table Body
  itemsToExport.forEach((item, idx) => {
    const curStock = fmtNum(item.current_stock);
    const minStock = fmtNum(item.minimum_stock);
    const costPrice = fmtNum(item.cost_price || item.purchase_price || item.buying_price);
    const sellPrice = fmtNum(item.selling_price || item.price || item.unit_price);
    const totalItemValuation = curStock * costPrice;

    let statusLabel = "Aman";
    if (curStock <= 0) {
      statusLabel = "Habis";
    } else if (curStock <= minStock) {
      statusLabel = "Menipis";
    }

    const variantLabel =
      item.variant_name || item.option_name || item.variant || (item.variants && item.variants.length > 1 ? "-" : "-");

    dataRows.push([
      idx + 1,
      item.product_code || item.barcode || item.code || "-",
      item.product_name || item.name || "-",
      variantLabel,
      item.category_name || item.category || "-",
      fmtNum(item.beginning_stock),
      fmtNum(item.stock_in),
      fmtNum(item.stock_out),
      curStock,
      (item.unit_name || item.unit || "PCS").toUpperCase(),
      minStock,
      statusLabel,
      costPrice,
      sellPrice,
      totalItemValuation,
    ]);
  });

  // 5. Grand Total Row
  dataRows.push([]);
  dataRows.push([
    "TOTAL KESELURUHAN",
    "",
    "",
    "",
    "",
    totalBeginningStock,
    totalStockIn,
    totalStockOut,
    totalCurrentStock,
    "",
    "",
    "",
    "",
    "",
    totalValuation,
  ]);

  const ws = XLSX.utils.aoa_to_sheet(dataRows);

  // Set column widths
  ws["!cols"] = [
    { wch: 6 },  // No
    { wch: 22 }, // Kode Produk
    { wch: 36 }, // Nama Produk
    { wch: 20 }, // Varian / Opsi
    { wch: 20 }, // Kategori
    { wch: 12 }, // Stok Awal
    { wch: 12 }, // Stok Masuk
    { wch: 12 }, // Stok Keluar
    { wch: 14 }, // Stok Saat Ini
    { wch: 10 }, // Satuan
    { wch: 14 }, // Stok Minimum
    { wch: 14 }, // Status Stok
    { wch: 18 }, // Harga Modal
    { wch: 18 }, // Harga Jual
    { wch: 22 }, // Total Nilai Modal
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Persediaan Stok");

  const todayStr = new Date().toISOString().slice(0, 10);
  const fileName = `Laporan_Persediaan_Stok_${todayStr}.xlsx`;
  XLSX.writeFile(wb, fileName);
}
